<template>
  <div>
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <user_component-vue></user_component-vue>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import headernav from "@/components/layouts/header.vue";
// import newproject from "@/components/modals-form/modal-newproject.vue";
import contentnew from "@/components/content.vue";
import user_componentVue from "../../components/user/user_component.vue";
export default {
  props: {
    source: String
  },
  components: {
    headernav,
    contentnew,
    user_componentVue
  },
  methods: {
    getUser() {
      return this.$store.getters["authentication/getUser"];
    },
    created() {
      this.$store.dispatch("users/getAll");
    }
  },
  created() {
    this.$store.dispatch("users/getAll");
  },
  data() {
    return {
      user: this.getUser()
    };
  },
  mounted() {
    
  }
};
</script>
